import { FileDataDisplay } from "#src/components/DataDisplay/FileDataDisplay";
import { Icon } from "@validereinc/common-components";
import type { ArtifactRefType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationDetailPage.module.scss";

const cx = classNames.bind(styles);

export type MessageArtifactListProps = {
  artifacts: ArtifactRefType[];
};

/**
 * Renders investigation message file artifacts with preview and download affordances.
 */
export const MessageArtifactList = ({
  artifacts,
}: MessageArtifactListProps) => {
  if (!artifacts.length) return null;

  return (
    <div
      className={cx("message-artifact-list", "message-artifact-list--download")}
      data-testid="message-artifact-list"
    >
      {artifacts.map((artifact) => (
        <div
          key={`${artifact.kind}-${artifact.ref.file_id}`}
          className={cx("message-artifact-list__download-item")}
          data-testid="message-artifact-item"
        >
          <FileDataDisplay
            fileName={artifact.name}
            fileId={artifact.ref.file_id}
            slotLeft={
              <Icon
                variant="file-text"
                size={16}
              />
            }
            shouldTruncateFilename
          />
        </div>
      ))}
    </div>
  );
};
